export default function initMobileMenu() {
    const toggleBtn = document.querySelector('.js-toggle-menu');
    const closeBtn = document.querySelector('.js-close-menu');
    const menuContainer = document.querySelector('.js-mobile-menu');
    const mainPanel = document.querySelector('.js-panel-main');

    const openSubPanelBtns = document.querySelectorAll('.js-open-subpanel');
    const closeSubPanelBtns = document.querySelectorAll('.js-close-subpanel');
    const subPanels = document.querySelectorAll('.js-panel-sub');

    const searchBtnMobile = document.querySelector('.js-toggle-search-mobile');
    const searchBtnDesktop = document.querySelector('.js-toggle-search');
    const searchCloseBtn = document.querySelector('.js-close-search');
    const searchOverlay = document.querySelector('.js-search-overlay');
    // const langDropdown removido daqui para evitar conflito

    function openMenu() {
        if (!menuContainer) return;
        menuContainer.classList.add('is-active');
        if (toggleBtn) toggleBtn.setAttribute('aria-expanded', 'true');
        menuContainer.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';

        setTimeout(() => {
            if (closeBtn) closeBtn.focus();
        }, 100);
    }

    function closeMenu(returnFocusToToggle = true) {
        if (!menuContainer) return;

        if (returnFocusToToggle && menuContainer.contains(document.activeElement)) {
            if (toggleBtn) toggleBtn.focus();
        }

        menuContainer.classList.remove('is-active');
        if (toggleBtn) toggleBtn.setAttribute('aria-expanded', 'false');
        menuContainer.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';

        setTimeout(() => {
            resetPanels();
        }, 300);
    }

    function openSubPanel(targetId) {
        const targetPanel = document.getElementById(`panel-${targetId}`);
        if (targetPanel) {
            targetPanel.classList.add('is-open');
            if (mainPanel) mainPanel.style.transform = 'translateX(-20%)';
        }
    }

    function closeSubPanel() {
        subPanels.forEach(panel => panel.classList.remove('is-open'));
        if (mainPanel) mainPanel.style.transform = 'translateX(0)';
    }

    function resetPanels() {
        closeSubPanel();
    }

    function toggleSearch(show) {
        if (!searchOverlay) return;

        if (show) {
            searchOverlay.classList.add('is-visible');
            searchOverlay.setAttribute('aria-hidden', 'false');
            if (searchBtnDesktop) searchBtnDesktop.setAttribute('aria-expanded', 'true');

            const input = searchOverlay.querySelector('input.orig');
            if (input) input.focus();

        } else {
            searchOverlay.classList.remove('is-visible');
            searchOverlay.setAttribute('aria-hidden', 'true');
            if (searchBtnDesktop) searchBtnDesktop.setAttribute('aria-expanded', 'false');

            if (searchBtnDesktop && window.getComputedStyle(searchBtnDesktop).display !== 'none') {
                searchBtnDesktop.focus();
            }
        }
    }

    if (toggleBtn) toggleBtn.addEventListener('click', openMenu);

    if (closeBtn) closeBtn.addEventListener('click', () => closeMenu(true));

    if (menuContainer) {
        menuContainer.addEventListener('click', (e) => {
            if (e.target === menuContainer) closeMenu(true);
        });
    }

    openSubPanelBtns.forEach(btn => {
        btn.addEventListener('click', (e) => {
            const target = e.currentTarget.getAttribute('data-target');
            openSubPanel(target);
        });
    });

    closeSubPanelBtns.forEach(btn => {
        btn.addEventListener('click', closeSubPanel);
    });

    if (searchBtnMobile) {
        searchBtnMobile.addEventListener('click', (e) => {
            e.preventDefault();

            if (searchOverlay) {
                searchOverlay.classList.add('is-visible');
                searchOverlay.setAttribute('aria-hidden', 'false');

                const input = searchOverlay.querySelector('input.orig');
                if (input) input.focus();
            }

            requestAnimationFrame(() => {
                closeMenu(false);
            });
        });
    }

    if (searchBtnDesktop) {
        searchBtnDesktop.addEventListener('click', (e) => {
            e.preventDefault();
            const isVisible = searchOverlay.classList.contains('is-visible');
            toggleSearch(!isVisible);
        });
    }

    if (searchCloseBtn) {
        searchCloseBtn.addEventListener('click', (e) => {
            e.preventDefault();
            toggleSearch(false);
        });
    }
}